export const PAGE_TITLE = 'PAGE_TITLE';